module.exports = __webpack_public_path__ + "static/media/logo-26.382b76cb.jpg";